import React, { memo } from 'react'
import { Box } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import TimerItem from '../TimerItem'
import { useTimer } from './Timer.hooks'

const Timer = props => {
	const [{ classes, timeRemaining, timerColour, data, getWording }, { handleDateBlockClick }] = useTimer(props)

	return (
		<Box className={clsx(classes.root, 'cta18-timer')} onClick={handleDateBlockClick}>
			{_.map(data, key => (
				<TimerItem
					key={key}
					timeRemaining={timeRemaining[key]}
					bgColour={timerColour}
					label={getWording(key)}
				/>
			))}
		</Box>
	)
}

Timer.propTypes = {
	date: PropTypes.string,
	handleDateBlockClick: PropTypes.func,
	timerColour: PropTypes.string,
}

export default memo(Timer)
